import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import type { ProductCard } from '../types';

/** Fetch featured products for the welcome-screen discovery rail. Best-effort. */
export function useFeaturedProducts(slug: string): ProductCard[] {
  const [products, setProducts] = useState<ProductCard[]>([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(
          `${API_URL}/api/stores/${encodeURIComponent(slug)}/featured`,
        );
        if (!res.ok) return;
        const json = await res.json();
        const list: ProductCard[] = json?.data?.products ?? json?.products ?? [];
        if (!cancelled) setProducts(list);
      } catch {
        // Non-critical: the welcome screen still works without the rail.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return products;
}
